import React, {forwardRef} from "react";
import {SystemFieldType,SystemPageType } from "../../../../Model/SystemModels";
import { CardField } from "../../../Common/Template/Card/CardField";
import { CardGroup } from "../../../Common/Template/Card/CardGroup";
import PageContainer, { PageContainerBase } from "../../../Common/Template/PageContainer";

export interface IAdminEmailTemplateProps {
    title: string;
}

export const AdminEmailTemplateCard = forwardRef<PageContainerBase, React.PropsWithChildren<IAdminEmailTemplateProps>>((props, ref) => {
    return (
        <PageContainer pageType={SystemPageType.Card} endpoint="/odata/email/template" title={props.title} ref={ref}>
            <CardGroup name="general" label="General" isOpen={true}>
                <CardField name="emailTemplateCode" label="Codice template" type={SystemFieldType.String} />
                <CardField name="description" label="Descrizione" type={SystemFieldType.String} />
                <CardField name="structureCode" label="Codice struttura" type={SystemFieldType.String} hasTableRelation tableRelationEndpoint="/odata/email/template/structure" tableRelationKey="code" tableRelationField="description" />
                <CardField name="emailType" type={SystemFieldType.Option} label="Tipologia" cmbOptions={[
                    {key: 0, text: "Application"},
                    {key: 1, text: "Advertising"}
                ]} />
            </CardGroup>
        </PageContainer>
    );
});